import React from "react";
import { Link } from "react-router-dom";
import "../component/css/Navbar.css";
function Navbar() {
  return (
    <div className="navbarfixed">
      <nav>
        <label className="logo">Major Project</label>
        <ul>
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>
            <Link to="/service">Services</Link>
          </li>
          <li>
            <Link to="/pricing"> Pricing</Link>
          </li>
          <li>
            <Link to="/faq">FAQ</Link>
          </li>
          <li>
            <Link to="/aboutus">About Us</Link>
          </li>
        </ul>
      </nav>

      <ul id="responsiveness-navbar">
        <li>
          <Link to="/" id="responsiveness-navbar-text">
            Home
          </Link>
        </li>
        <li>
          <Link to="/service" id="responsiveness-navbar-text">
            Services
          </Link>
        </li>
        <li>
          <Link to="/pricing" id="responsiveness-navbar-text">
            {" "}
            Pricing
          </Link>
        </li>
        <li>
          <Link to="/faq" id="responsiveness-navbar-text">
            FAQ
          </Link>
        </li>
        <li>
          <Link to="/aboutus" id="responsiveness-navbar-text">
            About Us
          </Link>
        </li>
      </ul>
    </div>
  );
}

export default Navbar;
